import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getCandidateDetails,
  updateHRNotes as updateHRNotesApi,
  scheduleInterview as scheduleInterviewApi,
} from "../api/candidates.api";

import {
  CandidateDetailsResponse,
  ScheduleInterviewPayload,
} from "../types";

// --------------------------------------------------
// Fetch Candidate Details
// --------------------------------------------------

export const fetchCandidateDetails = createAsyncThunk<
  CandidateDetailsResponse,
  string,
  { rejectValue: string }
>(
  "candidateDetails/fetchCandidateDetails",

  async (applicationId, thunkAPI) => {
    try {
      const response =
        await getCandidateDetails(applicationId);

      const body = response.data;

      if (!body?.success) {
        return thunkAPI.rejectWithValue(
          body?.message ||
            "Failed to fetch candidate details"
        );
      }

      return body.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to fetch candidate details"
      );
    }
  }
);

// --------------------------------------------------
// Update HR Notes
// --------------------------------------------------

export const updateHRNotes = createAsyncThunk<
  { applicationId: string; hrNotes: string },
  { applicationId: string; hrNotes: string },
  { rejectValue: string }
>(
  "candidateDetails/updateHRNotes",

  async ({ applicationId, hrNotes }, thunkAPI) => {
    try {
      const response =
        await updateHRNotesApi(
          applicationId,
          hrNotes
        );

      const body = response.data;

      if (body?.success === false) {
        return thunkAPI.rejectWithValue(
          body?.message ||
            "Unable to save HR notes."
        );
      }

      return {
        applicationId,
        hrNotes,
      };
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to save HR notes."
      );
    }
  }
);

// --------------------------------------------------
// Schedule Interview
// --------------------------------------------------

export const scheduleInterview = createAsyncThunk<
  {
    applicationId: string;
    interviewDetails: ScheduleInterviewPayload;
  },
  {
    applicationId: string;
    interviewDetails: ScheduleInterviewPayload;
  },
  { rejectValue: string }
>(
  "candidateDetails/scheduleInterview",

  async (
    {
      applicationId,
      interviewDetails,
    },
    thunkAPI
  ) => {
    try {
      const response =
        await scheduleInterviewApi(
          applicationId,
          interviewDetails
        );

      const body = response.data;

      if (body?.success === false) {
        return thunkAPI.rejectWithValue(
          body?.message ||
            "Unable to schedule interview."
        );
      }

      return {
        applicationId,
        interviewDetails,
      };
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message ||
          "Unable to schedule interview."
      );
    }
  }
);